import { Component } from '@angular/core';

@Component({
  selector: 'app-sales-aged-receivables',
  standalone: false,
  
  templateUrl: './sales-aged-receivables.component.html',
  styles: ``
})
export class SalesAgedReceivablesComponent {

}
